export class SectorModel {
  sectorId: number = 0;
  departmentId: number = 0;
  cityId: number = 0;
  consecutive: number = 0;
  name: string = '';
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
